module.exports = __webpack_public_path__ + "static/img/weather35.4c58c65b.png";